<template>
    <div id="editAbsenteeism" class="d-flex">
      <MainBarMenuV2 />
      <b-container class="container-fluid">
          <b-row>
              <!-- header -->
              <b-col cols="12">
                  <heading-user />
              </b-col>
              <!-- end -->
  
              <!-- navegacion -->
              <b-col
                  cols="12"
                  class="mt-3" >
                  <b-breadcrumb
                      :items="breadcrumbItems"
                      class="breadcrumb-v2" />
              </b-col>
              <!-- end -->
  
              <template v-if="loading">
                  <!-- elemento de carga -->
                  <b-col cols="12" >
                      <loader-version2 />
                  </b-col>
                   <!-- end -->
              </template>
  
              <template v-else>
                  <div>
                      <!-- titulo  -->
                      <b-col cols="12" class="mt-3">
                          <b-row class="d-flex align-items-center">
                              <img
                                  class="centerImg1 mr-2 ml-3"
                                  src="@/assets/images/icons/ht_icon_clock.svg"
                                  width="30px">
                              <h3 class="m-0 title-h3">Historial</h3>
                          </b-row>
                      </b-col>
                      <!-- end -->
  
                      <!-- informacion del usuario -->
                      <b-col cols="12" class="mt-5">
                          <worker-info-v2 :prop-user="employeeInfo.data.employee" />
                      </b-col>
                      <!-- end -->
  
                      <template v-if="loadData">
                          <div class="col-12">
                              <!-- ausentismo -->
                            <absenteeism
                                      class="mt-5"
                                      :dataUser="employeeInfo.data.employee"
                                      :userAbs="detailAbs.absenteeism"
                                      :totalAbsenteeism="detailAbs.summary"
                                      :filterButton="true"
                                      :HistoryButtonAbs="false"
                                      stadistics="detail"
                                      :time="detailAbs.time"
                                      :pagination="true"/>
                              <!-- end -->
  
                              <!-- estadisticas -->
                              <!-- <stadistics
                                  class="mt-5"
                                  :totalAbsenteeism="detailAbs.summary"
                                  :time="detailAbs.time"
                                  :justStadistics="false" /> -->
                              <!-- end -->
                          </div>
                      </template>
  
                  </div>
              </template>
          </b-row>
      </b-container>
     </div>
  </template>
  
  <script>
  import { mapState,mapActions } from "vuex";
  import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
  import HeadingUser from "../../components/user/HeadingUser.vue";
  
  export default {
      name: "editAbsenteeism",
      components: {
          MainBarMenuV2,
          HeadingUser,
          Absenteeism: () => import('../../components/healthTracker/editAbsenteeism.vue'),
          WorkerInfoV2: () => import('../../components/healthTracker/workerInfo/WorkerInfoV2.vue'),
      },
    data() {
        return {
          loadData: false,
          carlos: "hola",
          ausentismo: [],
        }
    },
    computed: {
      ...mapState("modOhAnalyst", [
          "loading",
          "loading2",
          "error",
          "message",
          "employeeInfo",
          "detailAbs",
      ]),
      ...mapState("modRequest", ["absenteeism"]),
      breadcrumbItems () {
          return [
              {
                  text: 'Conceptos Medicos',
                  href: '/employee'
              },
              {
                  text: 'Edición de ausentismos',
                  href: '#'
              }
          ]
      }
    },
    beforeMount() {
        let data = {
            id:this.$route.params.id,
        }
      if(this.$route.params.eid){
        this.actGetDetailAbsenteeism(data).then(() => {
            this.loadData = true
        })
        this.actGetEmployeeInfo(this.$route.params.id)
        this.actPreviousUser(this.$route.params.id)
      }
      //   this.actGetDetailAbsenteeism(data).then(() => {
      //       this.loadData = true
      //   })
  
      },
    methods: {
      ...mapActions("modOhAnalyst", [
          'actGetEmployeeInfo',
          'actGetDetailAbsenteeism',
          'actPreviousUser',
          'actGetAbsenteeism'
      ])
  
      }
  }
  </script>
  
  <style lang="scss">
  #detailAbsenteeism{
      .back{
       color: #269887;
      }
      .custom-select{
          padding: 10px 10px;
          font-size: 15px;
          height: 50px;
          border-radius: 10px;
      }
      .btn-create{
          padding: 12px;
          border-radius: 20px;
          background-color: #269887;
          border: none;
          color: white;
          display: flex;
          align-items: center;
          transition: 0.5s;
  
          span {
              font-size: 30px;
              line-height: 0;
              margin: 0 5px;
              font-weight: 500;
          }
      }
      .btn-create:hover{
          background-color: #27a391;
          box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
      }
      /*.status{
          padding: 5px 15px;
          border-radius: 5px;
      }*/
      .buttonColapse{
          background: rgba(38, 152, 135, 0.14);
          border: 2px solid #269887;
          color:#269887;
          font-size: 12px;
          border-radius: 100px;
      }
      .btn-outline-success:hover, .btn-success{
          color: white;
          background-color: #269887;
          border-color: #269887;
      }
      .btn-success:hover{
          background-color: #27a391;
      }
      .regular{
          background-color: white;
          border: none;
          color: #269887;
      }
      /*.table-views{
          box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
          border-radius: 8px;
          border:#DDDDDD solid 1px;
          padding: 0;
          margin: 30px 5px;
          font-size: 14px;
          .theading{
              width: 25%;
          }
      }
      .tableAbs{
          font-size: 14px;
          tbody tr{
              cursor: pointer;
          }
          tbody tr:hover{
              background-color: #F5F5F5;
          }
      }
      .t-head{
          background-color: #F5F5F5;
          padding: 5px 15px;
          text-align: left;
      }
      input{
          padding: 10px 10px;
          font-size: 15px;
          height: 50px;
          border-radius: 10px;
      }*/
  
  
  }
  .modal-content .modal-abs{
          font-family: Open Sans;
      h1{
          font-family: Poppins;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 36px;
          letter-spacing: 0em;
          text-align: center;
  
      }
      select.custom-select, input{
          padding: 10px 10px;
          font-size: 15px;
          height: 50px;
          border-radius: 10px;
      }
      .charge{
          border: 1px dashed #DDDDDD;
          border-radius: 8px;
      }
      .modal-header{
          border: none;
      }
      .input-vp2, button{
          padding: 10px 10px;
          font-size: 15px;
          height: 40px;
          border-radius: 10px;
  
      }
      .btn-outline-success{
          border-radius: 20px;
          color: #269887;
          border-color: #269887;
      }
      .btn-outline-success:hover, .btn-success{
          color: white;
          background-color: #269887;
          border-color: #269887;
      }
      .btn-success:hover{
          background-color: #27a391;
      }
      .regular{
          background-color: white;
          border: none;
          color: #269887;
      }
      .delete{
          background-color: white;
          border: none;
          color: #DA1414;
      }
      h3{
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 30px;
          text-align: center;
      }
      #loader2 {
              margin: 20px auto;
              z-index: 1;
              width: 100px;
              height: 100px;
              border: 15px solid #f3f3f3;
              border-radius: 50%;
              border-top: 15px solid #8f8f8f;
              -webkit-animation: spin 2s linear infinite;
              animation: spin 2s linear infinite;
          }
      .nav-tabs{
          a{
              color:black;
              padding: 5px 15px;
          }
          a.active {
              background: rgba(38, 152, 135, 0.06);
              border-radius: 4px;
              border: 0;
              border-bottom: solid 3px;
              border-color: #269887;
          }
      }
      .table-views{
          height: fit-content;
          border-radius: 8px;
          padding: 0;
          .t-head{
              background-color: #F5F5F5;
              padding: 5px 15px;
              text-align: left;
              font-size: 15px;
          }
          thead tr{
              background-color: #EEF2FA;
              border-radius: 10px;
              text-align: left !important;
          }
          .theading{
              padding: 15px 10px;
          }
          th.theading span{
              font-size: 15px;
          }
          tbody tr {
              border-radius: 10px;
          }
          tbody tr td{
              padding: 15px 10px;
              font-size: 14px;
          }
          .buttonColapse, .buttonColapse:hover,.buttonColapse:active{
              background-color: transparent;
              border:none;
              box-shadow:none;
          }
      }
      .formulario{
          h3{
              font-size: 16px;
              color: #1C3A4E;
              font-weight: 600;
          }
          .vc-container{
              font-family: Poppins;
              box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
              border: none;
                  .vc-grid-cell{
                      margin: 5px;
                  }
          }
      }
  }
  </style>
  